import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { makeStyles, useTheme } from '@material-ui/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative'
  }
}));

export const Chart = props => {
  const { className, data: dataProp, labels, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();

  const data = canvas => {
    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);

    gradient.addColorStop(0, fade(theme.palette.primary.main, 0.2));
    gradient.addColorStop(0.9, 'rgba(255,255,255,0)');
    gradient.addColorStop(1, 'rgba(255,255,255,0)');

    return {
      datasets: [
        {
          label: 'total',
          // fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: theme.palette.primary.main,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: theme.palette.primary.main,
          pointBackgroundColor: '#fff',
          pointHoverRadius: 5,
          pointHoverBackgroundColor: theme.palette.primary.main,
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointHitRadius: 10,
          pointBorderWidth: 3,
          pointRadius: 6,
          data: dataProp
        }
      ],
      labels
    };
  };

  const options = {
    // responsive: true,
    // maintainAspectRatio: false,
    // animation: true,
    // legend: {
    //   display: false
    // },
    // layout: {
    //   padding: 0
    // },
    scales: {
      xAxes: [
        {
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          },
          ticks: {
            padding: 20,
            fontColor: theme.palette.text.secondary
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            borderDash: [2],
            borderDashOffset: [2],
            color: theme.palette.divider,
            drawBorder: false,
            zeroLineBorderDash: [2],
            zeroLineBorderDashOffset: [2],
            zeroLineColor: theme.palette.divider
          },
          ticks: {
            padding: 20,
            fontColor: theme.palette.text.secondary,
            beginAtZero: true,
            min: 0,
            maxTicksLimit: 7,
            // callback: value => {
            //   // return value > 0 ? value + 'K' : value;
            //   return value > 0 ? value : value;
            // }
          }
        }
      ]
    }
    // tooltips: {
    //   enabled: true,
    //   mode: 'index',
    //   intersect: false,
    //   caretSize: 10,
    //   yPadding: 20,
    //   xPadding: 20,
    //   borderWidth: 1,
    //   borderColor: theme.palette.divider,
    //   backgroundColor: theme.palette.white,
    //   titleFontColor: theme.palette.text.primary,
    //   bodyFontColor: theme.palette.text.secondary,
    //   footerFontColor: theme.palette.text.secondary,
    //   callbacks: {
    //     title: () => {},
    //     label: tooltipItem => {
    //       let label = `Income: ${tooltipItem.yLabel}`;

    //       if (tooltipItem.yLabel > 0) {
    //         label += 'K';
    //       }

    //       return label;
    //     }
    //   }
    // }
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Line
        data={data}
        options={options}
        //
      />
    </div>
  );
};

Chart.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired
};

// export default Chart;
